module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-tee/16-0c215d872f1ab756e2b824e12a7f9e76.jpg";